type FormValue = {[key: string]: any};

export class KnowledgeTestFormService {
  formValues: FormValue;
  isTestPassed = false;
  isTestCompleted = false;

  setKnowledgeTestFormValues(values: FormValue): void {
    this.formValues = values;
  }

  getKnowledgeTestFormValues(): FormValue {
    return this.formValues;
  }

  getIsTestPassed(): boolean {
    return this.isTestPassed;
  }

  setIsTestPassed(isTestPassed: boolean): void {
    this.isTestPassed = isTestPassed;
  }

  getIsTestCompleted(): boolean {
    return this.isTestCompleted;
  }

  setIsTestCompleted(isTestCompleted: boolean): void {
    this.isTestCompleted = isTestCompleted;
  }

  reset(): void {
    this.isTestCompleted = false;
    this.isTestPassed = false;
    this.formValues = {};
  }
}
